import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const usePaginatedData = (fullData, perPage) => {
  const router = useRouter();
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    const { page } = router.query;
    const pageNumber = parseInt(page, 10) || 1;
    setCurrentPage(pageNumber);
  }, [router.query.page]);

  const start = (currentPage - 1) * perPage;
  const end = start + perPage;
  const slicedData = fullData?.slice(start, end);

  return { slicedData };
};

export default usePaginatedData;
